export enum ChainType {
  FIAT = "fiat",
  CRYPTO = "crypto",
}

export enum Chain {
  Ethereum = "eth",
  Tron = "tron",
  Polygon = "polygon",
  Euro = "eur",
  INR = "inr",
  PKR = "pkr",
  PHP = "php",
}

export enum OnmetaStatus {
  N_A = "n/a",
  PENDING = "PENDING",
  SUCCESS = "SUCCESS",
  FAILED = "FAILED",
}

export interface ChainDetails {
  value: Chain;
  name: string;
  type: ChainType;
  tokenStandard?: string;
  features?: string[];
}

export interface BaseWallet {
  id?: string;
  name: string;
  chain: Chain;
  address?: string;
  country?: string;
  bank_name?: string;
  bank_code?: string;
  account_number?: string;
  iban?: string;
  beneficiary_name?: string;
  bic?: string;
}

export interface Wallet extends BaseWallet {
  id: string;
  active: boolean;
  created_at: string;
  onmeta_status: OnmetaStatus;
}

export interface Bank {
  id: string;
  name: string;
  chain: Chain;
  codes?: Array<string>;
}
